import React from 'react'
import { Box } from '@mui/material'
import ButtonMoreInfos from '@/components/Common/ButtonMoreInfos'
import SectionTitle from '@/components/Common/SectionTitle'
import { getImageCsCart } from '@/lib/getImageCsCart'
import Link from 'next/link'
import { useRestQuery } from '@/lib/hook/tanstackQuery'
import Banner from '@/type/banner'
import { DefaultError } from '@tanstack/react-query'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'

const MostSearchedBrands: React.FC = () => {
  const { data, isLoading } = useRestQuery<{ banners: Banner[] }, DefaultError>({
    ...ApiQueryEndpoint.CMS.GET_BANNERS,
    queriesParams: { type: 'M' },
  })

  if (isLoading || !data || data?.banners?.length === 0) return null

  const dataBanners = data?.banners.slice(0, 5)

  return (
    <Box sx={{ width: '100%', py: 2 }}>
      <SectionTitle
        action={
          <ButtonMoreInfos
            to="/fr/view_brands/view?mode=marques"
            style={{ margin: 0 }}
          />
        }
      >
        Nos meilleures conditions
      </SectionTitle>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(5, 1fr)' },
          gap: 2,
        }}
      >
        {dataBanners.map((brand, index) => (
          <Link href={brand.url || '#'} key={index} passHref>
            <Box
              sx={{
                height: 100,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 0.5,
              }}
            >
              <img
                src={getImageCsCart(brand.main_pair)}
                alt={brand.banner}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Link>
        ))}
      </Box>
    </Box>
  )
}

export default MostSearchedBrands
